import React from "react";
import { Container } from "react-bootstrap";
import logo1 from "../../../Asset/ai/logo1.svg";
import logo2 from "../../../Asset/ai/logo2.svg";
import logo3 from "../../../Asset/ai/logo3.svg";
import logo4 from "../../../Asset/ai/logo4.svg";
import logo5 from "../../../Asset/ai/logo5.svg";
import logo6 from "../../../Asset/ai/logo6.svg";
import logo7 from "../../../Asset/ai/logo7.svg";
import logo8 from "../../../Asset/ai/logo8.svg";
import logo9 from "../../../Asset/ai/logo9.svg";
import logo10 from "../../../Asset/ai/logo10.svg";
import logo11 from "../../../Asset/ai/logo11.svg";
import logo12 from "../../../Asset/ai/logo12.svg";
import logo13 from "../../../Asset/ai/logo13.svg";
import logo14 from "../../../Asset/ai/logo14.svg";
import logo15 from "../../../Asset/ai/logo15.svg";
import logo16 from "../../../Asset/ai/logo16.svg";
import logo17 from "../../../Asset/ai/logo17.svg";
import logo18 from "../../../Asset/ai/logo18.svg";
import logo19 from "../../../Asset/ai/logo19.svg";
import logo20 from "../../../Asset/ai/logo20.svg";
import logo21 from "../../../Asset/ai/logo21.svg";
import logo22 from "../../../Asset/ai/logo22.svg";
import logo23 from "../../../Asset/ai/logo23.svg";
import logo24 from "../../../Asset/ai/logo24.svg";
import logo25 from "../../../Asset/ai/logo25.svg";
import logo26 from "../../../Asset/ai/logo26.svg";
import logo27 from "../../../Asset/ai/logo27.svg";
import logo28 from "../../../Asset/ai/logo28.svg";
import logo29 from "../../../Asset/ai/logo29.svg";
import logo30 from "../../../Asset/ai/logo30.svg";
import logo31 from "../../../Asset/ai/logo31.svg";
import logo32 from "../../../Asset/ai/logo32.svg";

const techData = [
  {
    category: "Generative AI Framework",
    items: [
      { name: "Langchain", imgSrc: logo1 },
      { name: "Llamaindex", imgSrc: logo2 },
      { name: "Haystack", imgSrc: logo3 },
      { name: "CrewAI", imgSrc: logo4 },
    ],
  },
  {
    category: "Generative AI Models",
    items: [
      { name: "Gemini", imgSrc: logo5 },
      { name: "OpenAI", imgSrc: logo6 },
      { name: "Llama", imgSrc: logo7 },
      { name: "Anthropic", imgSrc: logo8 },
      { name: "Mistral", imgSrc: logo9 },
      { name: "Stable Diffusion", imgSrc: logo10 },
      { name: "Midjourney", imgSrc: logo11 },
    ],
  },
  {
    category: "Machine Learning & Deep Learning",
    items: [
      { name: "Tensorflow", imgSrc: logo12 },
      { name: "Pytorch", imgSrc: logo13 },
      { name: "Keras", imgSrc: logo14 },
      { name: "Scikit", imgSrc: logo15 },
      { name: "Pandas", imgSrc: logo16 },
      { name: "Matplotlib", imgSrc: logo17 },
    ],
  },
  {
    category: "LLM Ops",
    items: [
      { name: "Hugging Face Transformers", imgSrc: logo18 },
      { name: "VLLM", imgSrc: logo21 },
      { name: "AWS Bedrock", imgSrc: logo20 },
      { name: "Azure Cloud", imgSrc: logo19 },
      { name: "Google Cloud", imgSrc: logo22 },
      { name: "Modal Serverless", imgSrc: logo23 },
    ],
  },
  {
    category: "Vector Database",
    items: [
      { name: "Pinecone", imgSrc: logo24 },
      { name: "ChromaDB", imgSrc: logo25 },
      { name: "Milvus", imgSrc: logo26 },
      { name: "Qdrant", imgSrc: logo27 },
    ],
  },
  {
    category: "Computer Vision",
    items: [
      { name: "OpenCV", imgSrc: logo28 },
      { name: "Dlib", imgSrc: logo29 },
      { name: "Ultralytics Yolo", imgSrc: logo30 },
      { name: "Control Net", imgSrc: logo31 },
      { name: "Automatic 1111", imgSrc: logo32 },
    ],
  },
];

const Sixth = () => {
  return (
    <section className="nineth-d2c-section">
      <Container>
        <div className="text_wrap">
          <h2>
            Advanced <strong> Technologies & Innovation</strong>
          </h2>
          <p className="store-success-intro">
            Utilizing the latest AI technologies and staying ahead of industry
            trends, we bring innovative solutions to drive your business
            forward.
          </p>
        </div>
        <div className="row nineth-d2c-main-row">
          <div className="col-12 nineth-d2c-main-col-1">
            <ul>
              {techData.map((techCategory, index) => (
                <li key={index}>
                  <div className="row tech-row first-tech-row">
                    <div className="col-12 col-lg-2 tech-col-1">
                      <h6>{techCategory.category}</h6>
                    </div>
                    <div className="col-12 col-lg-10 tech-col-2">
                      {techCategory.items.map((item, itemIndex) => (
                        <div className="tech-item" key={itemIndex}>
                          <div className="icon-border">
                            <img src={item.imgSrc} alt={item.name} />
                          </div>
                          <p>{item.name}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Sixth;
